module.exports = __webpack_public_path__ + "static/media/1POLICY1.ce5d92d7.jpg";